export default __webpack_public_path__ + "static/media/user-injured.ffc841f3.svg";